export default {
  path: '/operation',
  component: (resolve) => require(['@/views/operation/index.vue'], resolve),
  redirect: '/operation/node/ccs-vps-hosting',
  children: [
    {
      path: '/operation/rd',
      component: (resolve) => require(['@/views/operation/rd/index.vue'], resolve),
      redirect: '/operation/rd/celery-tasks',
      meta: { requireRD: true },
      children: [
        {
          path: '/operation/rd/vps-agent-upgrade',
          component: (resolve) =>
            require(['@/views/operation/rd/vpsAgentUpgrade/index.vue'], resolve),
          redirect: '/operation/rd/vps-agent-upgrade/list',
          // requireRD：仅 R&D 部门可见/可访问（后端 403 兜底）
          meta: { requireRD: true },
          children: [
            {
              path: '/operation/rd/vps-agent-upgrade/list',
              meta: { requireRD: true },
              component: (resolve) =>
                require(['@/views/operation/rd/vpsAgentUpgrade/BatchList.vue'], resolve)
            },
            {
              path: '/operation/rd/vps-agent-upgrade/:batchId',
              meta: { requireRD: true },
              component: (resolve) =>
                require(['@/views/operation/rd/vpsAgentUpgrade/BatchDetail.vue'], resolve)
            }
          ]
        },
        {
          path: '/operation/rd/vps-host-command',
          component: (resolve) =>
            require(['@/views/operation/rd/vpsHostCommand/index.vue'], resolve),
          redirect: '/operation/rd/vps-host-command/list',
          // requireRD + requireAdmin：仅 R&D 部门管理员可/可访问（后端 403 兜底)
          meta: { requireRD: true, requireAdmin: true },
          children: [
            {
              path: '/operation/rd/vps-host-command/list',
              meta: { requireRD: true, requireAdmin: true },
              component: (resolve) =>
                require(['@/views/operation/rd/vpsHostCommand/CommandList.vue'], resolve)
            },
            {
              path: '/operation/rd/vps-host-command/:batchId',
              meta: { requireRD: true, requireAdmin: true },
              // 复用升级详情组件，通过 props 切换接口前缀与标题
              props: { basePath: 'host_command_jobs', titleText: 'Host Command Detail' },
              component: (resolve) =>
                require(['@/views/operation/rd/vpsAgentUpgrade/BatchDetail.vue'], resolve)
            }
          ]
        },
        {
          path: '/operation/rd/celery-tasks',
          component: (resolve) => require(['@/views/operation/rd/celeryTasks/index.vue'], resolve)
        },
        {
          path: '/operation/rd/celery-tasks/:taskId',
          component: (resolve) =>
            require(['@/views/operation/rd/celeryTasks/TaskProfile.vue'], resolve)
        }
      ]
    },
    {
      path: '/operation/node/ccs-vps-hosting',
      component: (resolve) =>
        require(['@/views/operation/node/ccs-vps-hosting/HostingList.vue'], resolve)
    },
    // {
    //     path : '/operation/node/ccs-vps-servers',
    //     component: resolve => require(['@/views/operation/node/ccs-vps-servers/VPSList.vue'], resolve),
    // },
    // {
    //     path : '/operation/node/ironic-servers',
    //     component: resolve => require(['@/views/operation/node/ironic-servers/index.vue'], resolve),
    // },
    {
      path: '/operation/node/dedicated-servers',
      component: (resolve) =>
        require(['@/views/operation/node/dedicated-servers/index.vue'], resolve)
    },
    {
      path: '/operation/node/deployment-results',
      component: (resolve) =>
        require(['@/views/operation/node/deployment-results/DeploymentResultsList.vue'], resolve)
    },
    {
      path: '/operation/node/llm-node',
      component: (resolve) => require(['@/views/operation/node/llm-node/index.vue'], resolve)
    },
    {
      path: '/operation/node/llm-node/:id',
      component: (resolve) =>
        require(['@/views/operation/node/llm-node/LLMNodeDetail.vue'], resolve)
    },
    {
      path: '/operation/node/shared-endpoint',
      component: (resolve) => require(['@/views/operation/node/shared-endpoint/index.vue'], resolve)
    },
    {
      path: '/operation/node/shared-endpoint/:id',
      component: (resolve) =>
        require(['@/views/operation/node/shared-endpoint/SharedEndpointDetail.vue'], resolve)
    },
    {
      path: '/operation/asset/domain',
      component: (resolve) => require(['@/views/operation/asset/domain/index.vue'], resolve)
    },

    {
      path: '/operation/asset/rental/rental-servers',
      component: (resolve) => require(['@/views/operation/asset/rental/RentalServers.vue'], resolve)
    },
    {
      path: '/operation/asset/rental/rental-servers/:rentalId',
      component: (resolve) =>
        require(['@/views/operation/asset/rental/RentalServersDetail.vue'], resolve)
    },
    {
      path: '/operation/asset/providers/providers-server',
      component: (resolve) =>
        require(['@/views/operation/asset/providers/ProvidersServer.vue'], resolve)
    },

    {
      path: '/operation/service/service-mng',
      redirect: '/operation/service/service-mng/service-list',
      component: (resolve) => require(['@/views/operation/service/index.vue'], resolve),
      children: [
        {
          path: '/operation/service/service-mng/service-list',
          component: (resolve) =>
            require(['@/views/operation/service/serviceManagement/ServiceList.vue'], resolve)
        },
        {
          path: '/operation/service/service-mng/:serviceId',
          redirect: '/operation/service/service-mng/:serviceId/service-profile',
          component: (resolve) =>
            require(['@/views/operation/service/serviceManagement/index.vue'], resolve),
          children: [
            {
              path: '/operation/service/service-mng/:serviceId/service-profile',
              component: (resolve) =>
                require(['@/views/operation/service/serviceManagement/ServiceInfo.vue'], resolve)
            },
            {
              path: '/operation/service/service-mng/:serviceId/service-log',
              component: (resolve) =>
                require(['@/views/operation/service/serviceManagement/ServiceLog.vue'], resolve)
            },
            {
              path: '/operation/service/service-mng/:serviceId/service-dependent',
              component: (resolve) =>
                require([
                  '@/views/operation/service/serviceManagement/DependentService.vue'
                ], resolve)
            }
          ]
        }
      ]
    },
    {
      path: '/operation/clouds/cloud-list',
      component: (resolve) => require(['@/views/operation/clouds/cloud/index.vue'], resolve)
    },
    {
      path: '/operation/service/log-analysis',
      component: (resolve) =>
        require(['@/views/operation/service/logAnalysis/LogAnalysisList.vue'], resolve)
    },
    {
      path: '/operation/service/black-white-list',
      component: (resolve) => require(['@/views/operation/service/black/BlackList.vue'], resolve)
    },
    {
      path: '/operation/service/black-white-processes',
      component: (resolve) =>
        require(['@/views/operation/service/blackProcess/BlackProcessList.vue'], resolve)
    },
    {
      path: '/operation/service/black-white-Domain',
      component: (resolve) =>
        require(['@/views/operation/service/blackDomain/BlackDomainList.vue'], resolve)
    },
    {
      path: '/operation/service/banned-country',
      component: (resolve) => require(['@/views/operation/service/blackCountry/index.vue'], resolve)
    },
    {
      path: '/operation/deployment/app-version',
      redirect: '/operation/deployment/app-version/version-list',
      component: (resolve) =>
        require(['@/views/operation/deployment/appVersion/index.vue'], resolve),
      children: [
        {
          path: '/operation/deployment/app-version/version-list',
          component: (resolve) =>
            require(['@/views/operation/deployment/appVersion/Versions.vue'], resolve)
        },
        {
          path: '/operation/deployment/app-version/template-list',
          component: (resolve) =>
            require(['@/views/operation/deployment/appVersion/Templates.vue'], resolve)
        },
        {
          path: '/operation/deployment/app-version/mods',
          component: (resolve) =>
            require(['@/views/operation/deployment/appVersion/Mods.vue'], resolve)
        },
        {
          path: '/operation/deployment/app-version/image-upgrade',
          component: (resolve) =>
            require(['@/views/operation/deployment/appVersion/ImageUpgrade.vue'], resolve)
        }
      ]
    },
    {
      path: '/operation/deployment/os',
      component: (resolve) => require(['@/views/operation/deployment/os/index.vue'], resolve)
    },
    {
      path: '/operation/deployment/software-addons',
      component: (resolve) =>
        require(['@/views/operation/deployment/software-addons/index.vue'], resolve),
      redirect: '/operation/deployment/software-addons/version',
      children: [
        {
          path: '/operation/deployment/software-addons/version',
          component: (resolve) =>
            require(['@/views/operation/deployment/software-addons/VersionList.vue'], resolve)
        },
        {
          path: '/operation/deployment/software-addons/component',
          component: (resolve) =>
            require(['@/views/operation/deployment/software-addons/ComponentList.vue'], resolve)
        },
        {
          path: '/operation/deployment/software-addons/software',
          component: (resolve) =>
            require(['@/views/operation/deployment/software-addons/SoftwareList.vue'], resolve)
        },
        {
          path: '/operation/deployment/software-addons/category',
          component: (resolve) =>
            require(['@/views/operation/deployment/software-addons/CategoryList.vue'], resolve)
        }
      ]
    },
    {
      path: '/operation/deployment/llm-model',
      component: (resolve) =>
        require(['@/views/operation/deployment/llm-model/ModelList.vue'], resolve)
    },
    {
      path: '/operation/deployment/phpmyadmin',
      component: (resolve) =>
        require(['@/views/operation/deployment/phpmyadmin/PhpMyAdminList.vue'], resolve)
    },
    {
      path: '/operation/deployment/shared-ips',
      component: (resolve) =>
        require(['@/views/operation/deployment/shared-ips/SharedIpList.vue'], resolve)
    },
    {
      path: '/operation/deployment/block',
      component: (resolve) => require(['@/views/operation/deployment/block/index.vue'], resolve)
    },
    {
      path: '/operation/service/assist-service',
      component: (resolve) =>
        require(['@/views/operation/service/assistService/AssistService.vue'], resolve)
    },
    {
      path: '/operation/service/alerts',
      component: (resolve) => require(['@/views/operation/service/alerts/index.vue'], resolve)
    },
    {
      path: '/operation/cicd/project-list',
      component: (resolve) => require(['@/views/operation/cicd/project/index.vue'], resolve)
    },
    {
      path: '/operation/cicd/project-group',
      component: (resolve) => require(['@/views/operation/cicd/projects/index.vue'], resolve)
    },
    {
      path: '/operation/members',
      component: (resolve) => require(['@/views/operation/members/index.vue'], resolve)
    }
  ]
};
